<app-page-title title="Igreja"></app-page-title>
<h3>
  <label>Area &nbsp;</label>
  {{ area?.description }}
</h3>

<h3>
  <label>Igreja &nbsp;</label>
  {{ area?.church.description }}
</h3>

<h3>
  <label>Líder &nbsp;</label>
  {{ area?.leader?.name }}
</h3>

<button class="btn-back" mat-raised-button color="primary" [routerLink]="['/area']">&nbsp;&nbsp; Voltar</button>
